import { get, patch } from 'src/utils/networkUtils';

export async function listAppSettings() {
  const body = await get('/admin/app-settings');
  return Array.isArray(body?.data) ? body.data : [];
}

export async function updateAppSetting(key, isEnabled) {
  const body = await patch(`/admin/app-settings/${encodeURIComponent(key)}`, {
    is_enabled: isEnabled,
  });
  return body?.data ?? null;
}
